import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import DeleteAllCardsModal from './Modals/DeleteAllCardsModal/DeleteAllCardsModal.js';
import DeleteCardModal from './Modals/DeleteCardModal/DeleteCardModal.js';
import DeleteCardModalNew from './Modals/DeleteCardModalNew/DeleteCardModalNew.js';
import NewCardModal from './Modals/NewCardModal/NewCardModal.js';

const Overlays = ({ containerType }) => {
    return (jsxs(Fragment, { children: [jsx(NewCardModal, { containerType: containerType }), jsx(DeleteAllCardsModal, {}), jsx(DeleteCardModal, {}), jsx(DeleteCardModalNew, {})] }));
};

export { Overlays as default };
//# sourceMappingURL=index.js.map
